"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerService = exports.LoggerServiceEvent = void 0;
const lodash_1 = require("lodash");
const rxjs_1 = require("rxjs");
class LoggerServiceEvent {
}
exports.LoggerServiceEvent = LoggerServiceEvent;
class LoggerService {
    constructor(...ps) {
        this.localStream = new rxjs_1.Subject();
        this.prefixArr = ps;
    }
    get stream() {
        return this.localStream.asObservable();
    }
    get prefixes() {
        return this.prefixArr
            .map(p => p.name ? p.name : lodash_1.isFunction(p) ? p() : p)
            .filter(p => !!p);
    }
    console(type, ...args) {
        var _a;
        const d = new Date();
        const datestring = ('0' + d.getDate()).slice(-2) +
            '-' +
            ('0' + (d.getMonth() + 1)).slice(-2) +
            '-' +
            d.getFullYear() +
            ' ' +
            ('0' + d.getHours()).slice(-2) +
            ':' +
            ('0' + d.getMinutes()).slice(-2);
        const finalPrefixes = this.prefixes.map(p => {
            return `[${p}]`;
        });
        console[type](datestring, ...finalPrefixes, ...args);
        const logEvent = {
            type,
            args: [datestring, ...finalPrefixes, ...args]
        };
        this.localStream.next(logEvent);
        (_a = this.localUpstream) === null || _a === void 0 ? void 0 : _a.next(logEvent);
    }
    log(...args) {
        this.console('log', ...args);
    }
    logJson(...args) {
        this.console('log', ...args.map(a => JSON.stringify(a, null, 2)));
    }
    info(...args) {
        this.console('info', ...args);
    }
    error(...args) {
        this.console('error', ...args);
    }
    for(...ps) {
        var _a;
        const loggerService = new LoggerService(...this.prefixArr, ...ps);
        loggerService.localUpstream = (_a = this.localUpstream) !== null && _a !== void 0 ? _a : this.localStream;
        return loggerService;
    }
}
exports.LoggerService = LoggerService;
